var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 2.64835V7.46732C16.3333 8.12071 16.3333 8.44741 16.4605 8.69697C16.5723 8.9165 16.7508 9.09497 16.9703 9.20683C17.2199 9.33398 17.5466 9.33398 18.2 9.33398H23.0189M23.3333 11.6536V20.0673C23.3333 22.0275 23.3333 23.0076 22.9518 23.7563C22.6163 24.4149 22.0808 24.9503 21.4223 25.2858C20.6736 25.6673 19.6935 25.6673 17.7333 25.6673H10.2666C8.30644 25.6673 7.32635 25.6673 6.57766 25.2858C5.91909 24.9503 5.38366 24.4149 5.0481 23.7563C4.66663 23.0076 4.66663 22.0275 4.66663 20.0673V7.93398C4.66663 5.9738 4.66663 4.99371 5.0481 4.24502C5.38366 3.58645 5.91909 3.05102 6.57766 2.71546C7.32635 2.33398 8.30644 2.33398 10.2666 2.33398H14.0137C14.8698 2.33398 15.2978 2.33398 15.7006 2.43069C16.0577 2.51643 16.3991 2.65784 16.7123 2.84974C17.0655 3.06619 17.3682 3.36886 17.9735 3.97419L21.6931 7.69378C22.2984 8.29911 22.6011 8.60178 22.8175 8.95499C23.0094 9.26814 23.1508 9.60955 23.2366 9.96667C23.3333 10.3695 23.3333 10.7975 23.3333 11.6536Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.40dba699b23de2ea0499026bf2b13567.svg";
export { ForwardRef as ReactComponent };